//@ts-ignore
import React, { useEffect, PropsWithChildren, type ReactNode } from "react";

import { ContextualAnalyticsData } from "@atlassian/wac-analytics-bridge";
import { initAnalyticsWebClient } from "@atlassian/wac-analytics-web-client";

type Props = {
    children: ReactNode;
};

// CHANGED
export const AnalyticsProviders = ({ children }: PropsWithChildren<Props>) => {
    useEffect(() => {
        initAnalyticsWebClient();
    }, []);

    return <ContextualAnalyticsData>{children}</ContextualAnalyticsData>;
};

export default AnalyticsProviders;
